import { V_FORM_ENUM } from "@/CommonDP/VForm/utils";

const COMPONENT_ENUM = {
  TYPE: "jy-child",
  LABEL: "项目子项"
};
export const CHILD_TYPE = {
  USER: {
    LABEL: "用户在项目中所有子项",
    VALUE: "user"
  },
  PRJ_ALL: {
    LABEL: "项目所有子项",
    VALUE: "prjAll"
  }
};
export const schema = {
  group: V_FORM_ENUM.custom,
  type: COMPONENT_ENUM.TYPE,
  icon: "tree",
  label: COMPONENT_ENUM.LABEL,
  formItemFlag: true,
  component: require("./index.vue").default,
  options: {
    name: "",
    label: COMPONENT_ENUM.LABEL,
    requiredHint: " ",
    labelHidden: false,
    labelWidth: "",
    required: false,
    labelWrap: false, // 自动换行
    disabled: false,
    position: "",
    labelAlign: "",
    columnWidth: "200px",

    setting: "",

    type: COMPONENT_ENUM.TYPE,
    customClass: "",
    description: "",
    closable: true,
    closeText: "",
    showIcon: false,
    effect: "light",
    hidden: false,
    multiple2: false, // multiple 被vform下毒,暂用这个
    childType: CHILD_TYPE.PRJ_ALL.VALUE,
    childNameKey: "",
    onInitAndUpdate: ""
  },
  props() {
    return {
      setting: () => import("./setting.vue")
    };
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onMounted: [],
      onChange: ["value"]
    };
  },
  getSFC: () => {
    return "<div></div>";
  },
  zh: {
    [COMPONENT_ENUM.TYPE]: {
      label: "标签名称"
    }
  }
};
